import { useQuery } from "@tanstack/react-query";

import { FuturesPriceDto } from "api";
import { useFuturesService } from "contexts/ServiceProvider";
import { BaseApiError } from "services/apiHelpers";

export const GET_FUTURES_QUERY_KEY = "get-futures";

const useGetFutures = () => {
  const futuresService = useFuturesService();

  return useQuery<FuturesPriceDto[], BaseApiError>({
    queryKey: [GET_FUTURES_QUERY_KEY],
    queryFn: () => futuresService.getFutures(),
  });
};

export default useGetFutures;
